import { useUserContext } from "../../../context/user/user-context";
import { useAudio } from "../audio/context/audio-context";
import * as S from "./button-continue.style";
import { BiHeadphone } from "react-icons/bi";
import React from "react";

export const ButtonContinue = () => {
  const { continued, setContinued } = useUserContext();
  const { handlePlayPause, progressChaptersGroup } = useAudio();

  const values = Object.values(progressChaptersGroup);
  
  if (continued || values.length > 0) return null;
  

  return (
    <S.Wrapper>
      <S.ButtonContinune onClick={() => {
        setContinued();
        handlePlayPause();
      }}>
        <BiHeadphone size={20} />
        Continuar
      </S.ButtonContinune>
    </S.Wrapper>
  );
};
